/**
 * TeamModeWrapper - обёртка для страниц с режимом команды
 * 
 * Оборачивает страницу в TeamModeProvider и передаёт mode prop
 */

import type { ReactNode } from 'react';
import { TeamModeProvider } from '../../contexts/TeamModeContext';

interface TeamModeWrapperProps {
  mode: 'personal' | 'team';
  children: ReactNode;
}

export function TeamModeWrapper({ mode, children }: TeamModeWrapperProps) {
  return (
    <TeamModeProvider mode={mode}>
      {children}
    </TeamModeProvider>
  );
}

export default TeamModeWrapper;

